// SetningsMinne/TrialSentences.js
import React, {Component} from 'react';
import strings from '../../strings';
import {updateStepData} from '../../api';
import listen from '../../assets/listen.png';

// Audio asset packs you provide (Howler or HTMLAudio wrappers).
// Each should index steps: 0,1,2,... and have .play(), .pause()/stop(), .on('end', cb)
import {getTrialAudioPack, getTrialFeedbackPack} from './assets';

import './styles.scss';

class TrialSentences extends Component {
	constructor(props) {
		super(props);
		this.assets = {};
		this.answers = {};
		this._packKey = null;
	}

	buildPacks = () => {
		const langCode = strings.getLanguage();
		const {ageGroup, testKeyType} = this.props;

		this.assets = getTrialAudioPack(langCode, ageGroup, testKeyType) || {};
		this.answers =
			getTrialFeedbackPack(langCode, ageGroup, testKeyType) || {};
	};

	maybeInitAudio = () => {
		const {testKeyType, ageGroup} = this.props;
		const langCode = strings.getLanguage();

		// don’t init until testKeyType is actually present
		if (!testKeyType) return;

		const key = `${langCode}|${ageGroup}|${testKeyType}`;
		if (this._packKey === key) return;

		// pack changed (or first time) → rebuild + init
		this._packKey = key;
		this.stopAll();
		clearTimeout(this.timeout);

		this.buildPacks();
		this.initializeAudio();
	};

	componentDidMount() {
		this.maybeInitAudio();
	}

	componentDidUpdate(prevProps) {
		// if testKeyType was '' and later becomes 'adult-followup', this fixes it
		if (
			prevProps.testKeyType !== this.props.testKeyType ||
			prevProps.ageGroup !== this.props.ageGroup
		) {
			this.maybeInitAudio();
		}

		if (prevProps.currentStep !== this.props.currentStep) {
			this.startNewTask(this.props.currentStep);
		}

		const prevSD = prevProps.stepData || {};
		const nextSD = this.props.stepData || {};
		if (nextSD.answered && !prevSD.answered) {
			this.playFeedback(this.props.currentStep, nextSD.correct);
		}
	}

	initializeAudio = () => {
		Object.values(this.assets || {}).forEach((a) => a.load());
		Object.values(this.answers || {}).forEach((a) => a.load());
		this.timeout = setTimeout(
			() => this.startNewTask(this.props.currentStep),
			600
		);
	};

	startNewTask = (idx) => {
		this.stopAll();
		const sound = this.assets[idx];
		if (!sound) {
			console.warn('Missing audio for trial step', idx);
			return;
		}
		sound.play();
	};

	playFeedback = () => {
		updateStepData({feedbackDone: true});
	};

	stopAll = () => {
		const stop = (s) => {
			if (s.stop) s.stop();
			else if (s.pause) s.pause();
		};
		Object.values(this.assets).forEach(stop);
		Object.values(this.answers).forEach(stop);
	};

	render() {
		return (
			<div className="SetningsMinne">
				<img className="listen-image" src={listen} alt="" />
			</div>
		);
	}
}

export default TrialSentences;
